// extracted by mini-css-extract-plugin
export default {"body":"sideMenu_body__0LEkP","bodyItem":"sideMenu_bodyItem__EjRT7","sideMenuBox":"sideMenu_sideMenuBox__HSk8v","minHeightOnMenu":"sideMenu_minHeightOnMenu__0MgIi"};